//https://www.w3schools.com/js/js_cookies.asp
export default function getCookie(cname) {
	var name = cname + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

jQuery(document).on('click keypress', '#choose-language', function (e) {
	e.preventDefault();
	// Location/Language stuffs
	jQuery('.language-locations', jQuery(this).parent() ).toggleClass('!block');
});


/* Translate
    ---------------------------------------- */
jQuery('.current-language').on('click', function (e) {
	e.preventDefault();
});

var tongTranslate = {
	English: '<span class="language">English</span>',
	French: '<span class="language">Fran&ccedil;ais</span>',
	German: '<span class="language">Deutsch</span>',
	Spanish: '<span class="language">Espa&ntilde;ol</span>',
	Swedish: '<span class="language">Svenska</span>',
	Russian: '<span class="language">Pусский</span>',
	Portuguese: '<span class="language">Português</span>',
};
var tongFlag = {
	English: 'flag flag-gb',
	French: 'flag flag-fr',
	German: 'flag flag-de',
	Spanish: 'flag flag-es',
	Swedish: 'flag flag-sv',
	Russian: 'flag flag-ru',
	Portuguese: 'flag flag-pt',
};

jQuery('ul a', '.translate').on('click', function (e) {
	e.preventDefault();
	var lang = jQuery(this).attr('title');
	setTranslation(lang);
	jQuery('.language-locations', jQuery(this).parents('.translate') ).toggleClass('!block');
});

function setTranslation(lang) {
	let flags = jQuery('#choose-language .flag');
	let text = jQuery('#choose-language .language');

	jQuery(flags).each(function () {
		jQuery(this).removeClass().addClass(tongFlag[lang]);
	});

	jQuery(text).each(function () {
		jQuery(this).replaceWith(tongTranslate[lang]);
	});
}

function setCurrentLang() {
	if(typeof cookie === undefined || typeof cookie === 'undefined') return;

	if(cookie.lang == 'en'){
		setTranslation('English');
	} 
	else if (cookie.lang == 'fr') {
		setTranslation('French');
	} else if (cookie.lang == 'de') {
		setTranslation('German');
	} else if (cookie.lang == 'es') {
		setTranslation('Spanish');
	} else if (cookie.lang == 'sv') {
		setTranslation('Swedish');
	} else if (cookie.lang == 'ru') {
		setTranslation('Russian');
	} else if (cookie.lang == 'pt') {
		setTranslation('Portuguese');
	}
}
setCurrentLang();
